var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.576,
    height: 15.5,
    viewBox: "0 0 14.576 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-pencil",
    d: "M10.932,0,9.11,1.938l3.644,3.875,1.822-1.937ZM7.288,3.875,0,11.625V15.5H3.644l7.288-7.75Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.edd53cf13449b1a9315b54fc2a7c408d.svg";
export { ForwardRef as ReactComponent };